const { userAgent } = window.navigator;

export const isMac = userAgent.includes('Mac');
export const isWin = userAgent.includes('Windows');

export const ctrlKeyStr = isMac ? '⌘' : 'Ctrl';
export const shiftKeyStr = isMac ? '⇧' : 'Shift';
export const deleteKeyStr = isMac ? 'Backspace' : 'Delete';

// used in ahooks' usekeypress
export const ctrlKey = isMac ? 'meta' : 'ctrl';
export const shiftKey = 'shift';

export const isCtrlKey = (e: KeyboardEvent): boolean => (isMac ? e.metaKey : e.ctrlKey);
export const isDeleteKey = (e: KeyboardEvent): boolean =>
  isMac ? e.code === 'Backspace' : e.code === 'Delete';
export const isInputTag = (el: HTMLElement): boolean =>
  el.tagName === 'INPUT' || el.tagName === 'TEXTAREA';
